import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import './app/overlay-dropdown-fix';

if (environment.production) {
  enableProdMode();
  window.document.getElementById('appFavicon').setAttribute('href', 'assets/favicons/prod-favicon.png');
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));

